const AppSettings = {
    "stat.gbbt.ru:": {
        apiUrl: "https://gymboss.gbbt.ru"
    },
    "stat.ptbt.site:": {
        apiUrl: "https://gymbossbot.ptbt.site"
    },
    "stat.ptbt.ru:": {
        apiUrl: "https://gymbossbot.ptbt.ru"
    },
    "stat.ptbt.tech:": {
        apiUrl: "https://gymbossbot.ptbt.tech"
    }
}

export default AppSettings